import { TextEmphasisKeys } from '@/constants/enum';
import styled from 'styled-components';

interface IProps {
  backgroundColor: string;
  contentColor: string;
  selected?: boolean;
  messageColor: string;
  messageSize: string;
  messageEmphasis: string;
  titleColor?: string;
}

export const BannerStatusCardStyled = styled.div<IProps>`
  .banner-status-card {
    background-color: ${(p) => p.backgroundColor};
    border-radius: 8px;
    gap: 11px;
    width: 100%;
    padding: 18px 14px;
    border: ${(p) => `2px solid ${p.selected ? '#005BD3' : p.contentColor}`};
    margin-top: 8px;
    overflow: hidden;
    .status-card-item {
      min-width: 15px;
    }

    .status-card-content {
      &.w-full-important {
        width: 100% !important;
      }
      width: 100%;
      .status-card-content-title {
        color: ${(p) => p.titleColor};
        font-weight: 500;
        font-size: 0.875rem;
      }
      .status-card-content-text {
        color: ${(p) => p.messageColor};
        font-size: ${(p) => p.messageSize};
        font-weight: ${(p) => (p.messageEmphasis === TextEmphasisKeys.bold ? p.messageEmphasis : undefined)};
        font-style: ${(p) => (p.messageEmphasis === TextEmphasisKeys.italic ? p.messageEmphasis : undefined)};
      }

      .status-card-content-title-empty {
        height: 25px;
        background-color: ${(p) => p.contentColor};
        margin-bottom: 12px;
        width: 100%;
        border-radius: 5px;
      }

      .status-card-content-text-empty {
        height: 14px;
        background-color: ${(p) => p.contentColor};
        width: 80%;
        border-radius: 5px;
      }
    }
  }
`;
